import type { ServicioEndesaModel } from "@api/api";

export class DatosServicioEndesa implements ServicioEndesaModel {
    Miscelanea: string = '';
}